import List from 'list.js';

export function events() {
  const root = document.querySelector('.archive-events');
  if(!root) return;

  const eventsList = new List(root, {
    page: 1000,
    valueNames: [
      { name: 'dates', attr: 'data-dates' }
    ]
  });

  const countEl = root.querySelector('.events-count');
  const updateCount = function() {
    if(countEl && typeof fabfLabels !== 'undefined' && fabfLabels.eventsCount) {
      countEl.textContent = fabfLabels.eventsCount.replace('%d', eventsList.visibleItems.length);
    }
  };

  eventsList.on('filterComplete', updateCount);

  const pills = root.querySelectorAll('.date-pill');
  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      const slug = pill.dataset.date;
      pills.forEach(function(p) { p.classList.remove('active'); });
      pill.classList.add('active');
      if(!slug) {
        eventsList.filter();
      } else {
        eventsList.filter(function(item) {
          return (item.values().dates || '').split(' ').indexOf(slug) !== -1;
        });
      }
      updateCount();
    });
  });
}
